import state from './state'

const getters = {
  getAccessToken () {
    return state.accessToken
  },
  getUser () {
    return state.user
  },
  getPermission () {
    return state.permission
  },
  getAllPermission () {
    return state.allPermission
  },
  dateFormat () {
    return state.dateFormat
  },
  getCurrentUserRole () {
    return state.currentUserRole
  },
  getCurrentUserId () {
    return state.currentUserId
  },
  getCurrentUserName () {
    return state.currentUserName
  },
  getAllUsers () {
    return state.allUsers.filter(user => !(user.deleted_at || user.exit_at))
  },
  getAllUsersWithTrashed () {
    return state.allUsers
  },
  isActive () {
    return state.isActive
  },
  getPriorities () {
    return state.priorities
  },
  getRoles () {
    return state.roles
  },
  getIssueTypes () {
    return state.issueTypes
  },
  getIssueStatuses () {
    return state.issueStatuses
  },
  getNotEstimatedIssues () {
    return state.notEstimatedIssues
  },
  getNotBudgetIssues () {
    return state.notBudgetIssues
  },
  getProjectStatuses () {
    return state.projectStatuses
  },
  getExpensesCategories () {
    return state.expensesCategories
  },
  getExpensesStatuses () {
    return state.expensesStatuses
  },
  getCurrencies () {
    return state.currencies
  },
  getBankCards () {
    return state.bankCards
  },
  getShowSidebar () {
    return state.showSidebar
  }
}

export default getters
